import { render, staticRenderFns } from "./PresupuestosInternosABM.vue?vue&type=template&id=6903b97c&"
import script from "./PresupuestosInternosABM.vue?vue&type=script&lang=js&"
export * from "./PresupuestosInternosABM.vue?vue&type=script&lang=js&"
import style0 from "./PresupuestosInternosABM.vue?vue&type=style&index=0&id=6903b97c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports